export default {
  execute(input) {
    // verify if input has content
    for(var prop in input) {
      if(input[prop]===undefined || input[prop] === null || input[prop].length===0) {
        var res = {};
        res.err = true;
        res.msg = prop + ' values missing';
        return res;
      }
    }

    var criteria = input['criteria'];
    var options = input['options'];

    var results = [];
    var ranking = [];
    var i,j;

    for(var i=0; i<options.length; i++) {
      results=0;
      for(var j=0; j<criteria.length; j++) {
        results+=criteria[j]['Weight'] * options[i][criteria[j]['Name']];
      }
      ranking[i] = {'Name': options[i]['Name'], 'Score': results};
    }
   ranking.sort(compareOptions);
   return ranking;

  function compareOptions(a, b) {
    if(a['Score']>b['Score'])
      return -1;
    else
      return 1;
   }
  }
}


// WEBPACK FOOTER //
// ./src/services/AdditiveAggregationService.js